import type { FeatureMetadata } from '../../types';
import { saveToStorage } from '../storage-api-utils';

export const saveMetadata = (
    metadataKey: string,
    metadata: FeatureMetadata,
    storage: Storage
) => {
    saveToStorage(metadataKey, metadata, storage);
};
